module.exports = __webpack_public_path__ + "static/1-91b8cc6bb59b764d8b981e2014b9322e.jpg";